import { Link } from 'react-router-dom';
import logo002 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.002.png';
import logo006 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.006.png';
import logo008 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.008.png';
import logo010 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.010.png';
import logo013 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.013.png';
import logo021 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.021.png';
import heroImage from '../assets/images/buillding-scaled.webp';

const solutions = [
  {
    title: 'Infrastructure Systems',
    description: 'Design, procurement, installation, and commissioning of mission-critical infrastructure.',
    to: '/infrastructure-systems'
  },
  {
    title: 'Network Systems',
    description: 'Integrated network solutions that balance performance, resilience, and security.',
    to: '/network-systems'
  },
  {
    title: 'Data Center Solutions',
    description: 'Scalable data center products, modernization, and lifecycle operations.',
    to: '/data-center'
  },
  {
    title: 'Information Security',
    description: 'Security architecture, governance, and managed defenses for evolving threats.',
    to: '/information-security'
  },
  {
    title: 'Virtualization',
    description: 'Abstraction layers that maximize hardware utilization across servers, desktops, and networks.',
    to: '/virtualization'
  },
  {
    title: 'Professional Services',
    description: 'Consulting, deployment, and managed operations that keep your IT ecosystem future-ready.',
    to: '/professional-services'
  }
];

const partnerLogos = [logo002, logo006, logo008, logo010, logo013, logo021];

const Home = () => {
  return (
    <>
      <section className="hero" style={{
        backgroundImage: `url(${heroImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}>
        <div className="container hero-content">
          <div className="breadcrumb" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Securing Progress</span>
          </div>
          <h1>Delivering Integrated Technology That Secures Your Progress</h1>
          <p>
            Nexus IT delivers end-to-end technology solutions from design to ongoing operations. We blend global
            expertise with local insight to deliver secure, scalable, and future-ready infrastructures for enterprises
            across Pakistan.
          </p>
          <div className="hero-actions">
            <Link className="btn btn-primary" to="/contact">Discuss Your Project</Link>
            <Link className="btn btn-outline" to="/solutions">Explore Solutions</Link>
          </div>
        </div>
      </section>

      <section className="quick-services">
        <div className="quick-services-inner">
          <div className="quick-services-grid">
            <div className="quick-service-item">
              <div className="quick-service-icon">
                <img src="/image.png" alt="Infrastructure Services" />
              </div>
              <h3 className="quick-service-title">Infrastructure Services</h3>
              <p className="quick-service-description">
                Connect unlimited networks and integrate vast amount of data to revolutionize & digitize operations.
              </p>
            </div>

            <div className="quick-service-item">
              <div className="quick-service-icon">
                <img src="/image-1.png" alt="Technological Solutions" />
              </div>
              <h3 className="quick-service-title">Technological Solutions</h3>
              <p className="quick-service-description">
                Process management and integrations to improve & transform business performance across multiple digital channels.
              </p>
            </div>

            <div className="quick-service-item">
              <div className="quick-service-icon">
                <img src="/image-2.png" alt="Business Process Outsourcing" />
              </div>
              <h3 className="quick-service-title">Business Process Outsourcing</h3>
              <p className="quick-service-description">
                Our well-versed team of Business Process Outsourcing experts always have a eye on increasing your market share & client base.
              </p>
            </div>
          </div>

          <div className="quick-services-cta">
            <Link className="btn" to="/solutions">
              Learn More
            </Link>
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container">
          <div className="section-header">
            <span className="tagline">What Drives Nexus IT</span>
            <h2 className="section-title">Innovation, Intelligence &amp; Integration</h2>
            <p className="section-lead">
              We align technology with your strategic objectives—designing scalable, secure ecosystems that accelerate
              digital transformation and empower your teams.
            </p>
          </div>

          <div className="split" style={{marginBottom: '3rem'}}>
            <div className="text-block">
              <p style={{marginBottom: '1rem'}}>
                Our team combines deep technical expertise with business acumen to deliver solutions that not only meet 
                current requirements but also anticipate future needs. We pride ourselves on being at the forefront of 
                technology trends while maintaining practical, results-focused implementation approaches.
              </p>
            </div>
            <div style={{position: 'relative', borderRadius: '5px', overflow: 'hidden', boxShadow: 'var(--shadow)'}}>
              <img src="/Pictures/p1.jpg" alt="Innovation Team at Work" style={{width: '100%', height: '250px', objectFit: 'cover'}} />
            </div>
          </div>

          <div className="cards">
            <article className="card">
              <h3>Our Vision</h3>
              <p>
                Become a global leader in technology services by delivering cutting-edge, sustainable solutions that
                solve complex business challenges.
              </p>
            </article>
            <article className="card">
              <h3>Our Commitment</h3>
              <p>
                Provide continuous support through highly skilled experts focused on excellence, customization, and
                long-term value for every client engagement.
              </p>
            </article>
            <article className="card">
              <h3>Our Goal</h3>
              <p>
                Elevate organizational efficiency with resilient, high-performing, and cost-effective solutions that
                drive measurable impact and future-ready infrastructures.
              </p>
            </article>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="tagline">End-to-End Capabilities</span>
            <h2 className="section-title">Solutions &amp; Services Portfolio</h2>
            <p className="section-lead">
              From infrastructure and cybersecurity to cloud transformation and managed services, Nexus IT orchestrates
              the complete technology lifecycle.
            </p>
          </div>

          <div className="split" style={{marginBottom: '3rem'}}>
            <div className="text-block">
              <img src="/Pictures/p2.jpeg" alt="Infrastructure Solutions" style={{width: '100%', height: '200px', objectFit: 'cover', borderRadius: '5px', marginBottom: '1.5rem'}} />
              <h4 style={{color: 'var(--primary)', marginBottom: '0.5rem'}}>Enterprise Infrastructure</h4>
              <p>From data center design to complete network implementation, our infrastructure solutions form the backbone of digital transformation.</p>
            </div>
            <div className="text-block">
              <img src="/Pictures/p3.jpg" alt="Security Solutions" style={{width: '100%', height: '200px', objectFit: 'cover', borderRadius: '5px', marginBottom: '1.5rem'}} />
              <h4 style={{color: 'var(--primary)', marginBottom: '0.5rem'}}>Security & Compliance</h4>
              <p>Comprehensive security frameworks that protect your digital assets while ensuring regulatory compliance and business continuity.</p>
            </div>
          </div>

          <div className="cards">
            {solutions.slice(0, 4).map((solution) => (
              <article className="card" key={solution.title}>
                <h3>{solution.title}</h3>
                <p>{solution.description}</p>
                <Link className="card-link" to={solution.to}>
                  View details →
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container split">
          <div className="text-block">
            <span className="badge">Why Nexus IT</span>
            <h2>Trusted Partner From Strategy To Support</h2>
            <p>
              Nexus IT is a registered Islamabad-based firm delivering secure, transparent, and cost-effective
              technology services. We go beyond traditional IT support to deliver measurable business outcomes.
            </p>
            <ul className="checklist">
              <li>Authorized partnerships with leading global OEMs</li>
              <li>End-to-end project ownership from supply to after-sales</li>
              <li>Experienced experts for government &amp; enterprise engagements</li>
              <li>Competitive pricing through direct alliances</li>
            </ul>
            <Link className="btn btn-primary" to="/why-nexus">
              Discover More
            </Link>
          </div>
          <div>
            <div style={{position: 'relative', borderRadius: '5px', overflow: 'hidden', boxShadow: 'var(--shadow)', marginBottom: '2rem'}}>
              <img src="/Pictures/p4.jpg" alt="Our Expert Team" style={{width: '100%', height: '300px', objectFit: 'cover'}} />
            </div>
            <div className="stat-grid">
              <article className="stat-card">
                <h4>Customer Centric</h4>
                <p>Dedicated account teams and SLAs ensure continuous alignment with your objectives.</p>
              </article>
              <article className="stat-card">
                <h4>Security Focused</h4>
                <p>Confidentiality and protection are built into every layer of our solutions.</p>
              </article>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="tagline">Strategic Alliances</span>
            <h2 className="section-title">Global Technology Partners</h2>
            <p className="section-lead">We collaborate with industry leaders to deliver reliable and innovative solutions.</p>
          </div>
          <div className="logo-grid" aria-label="Partner logos">
            {partnerLogos.map((logo) => (
              <img src={logo} alt="Partner logo" key={logo} />
            ))}
          </div>
          <div style={{ marginTop: '2.5rem', textAlign: 'center' }}>
            <Link className="btn btn-primary" to="/alliances">
              View All Partners
            </Link>
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2>Ready to Modernize Your Technology Landscape?</h2>
              <p>
                Connect with our consultants to design a secure, scalable, and intelligent solution tailored to your
                enterprise.
              </p>
            </div>
            <Link className="btn btn-white" to="/contact">
              Talk to Nexus IT
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
